import { render } from "./Step3_3.vue?vue&type=template&id=9fe4d7c8&ts=true"
import script from "./Step3_3.vue?vue&type=script&lang=ts"
export * from "./Step3_3.vue?vue&type=script&lang=ts"

import "./Step3_3.vue?vue&type=style&index=0&id=9fe4d7c8&lang=scss"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__